<template>
  <div class="tree-main">
    <div class="tree-top">
      <div :class="{ 'tree-title': true, active: !activeId }" @click="clearClick">
        <div class="flex flex-y-center">
          <i class="el-icon-office-building m-r-2" />
          <span>组织架构({{ allPersonCount }})</span>
        </div>
      </div>
      <div class="flex flex-y-center">
        <el-link type="success" @click="departmentJump">架构管理</el-link>
        <el-link type="primary" @click="departmentToggle">
          {{ isExpandAll ? '收起↑' : '展开↓' }}
        </el-link>
      </div>
    </div>
    <div class="tree-bottom">
      <el-tree
        ref="refTree"
        :data="listData"
        :props="treeProps"
        :expand-on-click-node="false"
        :indent="12"
        node-key="id"
        default-expand-all
        @node-click="itemClick"
      >
        <template slot-scope="{ data }">
          <div class="tree-item" :title="`${data.name}(${data.person_count})`">
            <i v-if="!data.parent_id" class="f-s-12 m-r-2 el-icon-school" />
            <i v-else class="f-s-12 m-r-2 iconfont icon-folder" />
            <div class="tree-name ellipsis">{{ data.name }}</div>
            <div>({{ data.person_count }})</div>
          </div>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isExpandAll: true,
      listData: [],
      treeProps: {
        label: 'name'
      }
    }
  },
  computed: {
    allPersonCount() {
      return this.listData.reduce((pre, cur) => pre + cur.person_count, 0)
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 获取列表数据
    getListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/columnData/treeList' // /admin/gcvip/bumen/list
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.listData = res.data.list
        }
      })
    },
    // 跳转部门管理
    departmentJump() {
      window.open('/company/jiagou/department', '_blank')
    },
    // 切换
    departmentToggle() {
      this.isExpandAll = !this.isExpandAll
      const nodesMap = this.$refs.refTree.store.nodesMap
      for (const key in nodesMap) {
        nodesMap[key].expanded = this.isExpandAll
      }
    },
    // 项-点击
    itemClick(data) {
      this.$emit('update:activeId', data.id)
    },
    // 清空-点击
    clearClick() {
      this.$emit('update:activeId', '')
      this.$refs.refTree.setCurrentKey()
    }
  }
}
</script>

<style lang="less" scoped>
.tree-main {
  color: #606266;
  .tree-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    .tree-title {
      display: flex;
      align-items: center;
      padding: 0 5px;
      margin-right: 5px;
      line-height: 28px;
      border-radius: 3px;
      cursor: pointer;
      &:hover {
        background: #f5f7fa;
      }
      &.active {
        color: #66b1ff;
        background: #ecf5ff;
      }
    }
  }
  .tree-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 38px;
    overflow-y: auto;
    border-top: 1px solid #e4e7ed;
    .scroll-bar();
    .tree-item {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      margin-right: 5px;
      .tree-name {
        width: auto;
      }
    }
  }
}
</style>
